import React from "react";
import "./CategoryBlock.css";
import SubTitle from "@components/common/Titles/SubTitle";
import { assetsUrl } from "../../constants";
import CategoryBlockLeft from "./CategoryBlockLeft";
import CategoryBlockRight from "./CategoryBlockRight";

function CategoryBlock({ containerData, title, hasBreadcrumbs, wordsToRemove, buttonLink }) {
  let firstPostData;
  let postsContainerRightData;
  if(wordsToRemove){
    if (containerData.list) {
      firstPostData = containerData.list.filter(item => {
        return !wordsToRemove.some(word => item.title.toLowerCase().includes(word));
      })[0];
      postsContainerRightData = containerData.list.filter(item => {
        return !wordsToRemove.some(word => item.title.toLowerCase().includes(word));
      }).slice(1);
    } else if (containerData.hits) {
      firstPostData = containerData.hits.filter(item => {
        return !wordsToRemove.some(word => item.title.toLowerCase().includes(word));
      })[0];
      postsContainerRightData = containerData.hits.filter(item => {
        return !wordsToRemove.some(word => item.title.toLowerCase().includes(word));
      }).slice(1, 6);
    }
  }else{
    if (containerData.list) {
      firstPostData = containerData.list[0];
      postsContainerRightData = containerData.list.slice(1);
    } else if (containerData.hits) {
      firstPostData = containerData.hits[0];
      postsContainerRightData = containerData.hits.slice(1, 6);
    }
  }
  return (
    <div id="recent-post">
      <SubTitle subTitleText={title} />
      <div className="category-block__wrapper">
        <div className="category-block__left">
          <CategoryBlockLeft
            hasBreadcrumbs={hasBreadcrumbs}
            firstPostData={firstPostData}
          />
        </div>
        <div className="category-block__right">
          {postsContainerRightData.map((item, index) => {
            // get thumbnail url
            let thumbnail_url =
              item.thumbnail_url ||
              assetsUrl +
                item.banner_image.base_url +
                "184/94/" +
                item.banner_image.file;

            // get post date
            let date = item.created_time * 1000 || item.published;

            // get postDetail url(post img and title are wrapped in link with this url)
            let url = item.url || item.links.detail;

            // Boolean variable wich shows if we have third patry service inside Post link or not
            // get category url for PostInfo block
            let categoryUrl = item?.category?.slug || item["owner.url"];

            // get category name for PostInfo block
            let categoryName =
              item?.category?.title || item["owner.screenname"];
            return (
              <CategoryBlockRight
                key={index}
                thumbnail_url={thumbnail_url}
                date={date}
                title={item.title}
                url={url}
                categoryUrl={categoryUrl}
                categoryName={categoryName}
              />
            );
          })}
        </div>
      </div>
      <div className="category-block__bottom-wrapper">
        <a className="category-block__bottom-button" href={buttonLink}>Lainnya</a>
      </div>
    </div>
  );
}

export default CategoryBlock;
